import { createEvent } from 'effector';

export const putSocdemDataEv = createEvent();
